import * as types from '../ActionTypes/MembershipPlansActionTypes';
import { MembershipPlanModel } from '../../BusinessLogic/Models/MembershipPlanModel';
import { getMembershipPlanModelsArray } from './helpers';

const initialState = {
    statuses: {
        arePlansLoading: false,
        isPlanAdding: false,
        isPlanUpdating: false,
        isPlanDeleting: false,
    },
    plans: [],
};

export function MembershipPlansReducer(state = initialState, { type, payload, meta, ...action }) {
    switch (type) {
        case types.GET_MEMBERSHIP_PLANS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    arePlansLoading: true,
                },
            };
        }

        case types.GET_MEMBERRHIP_PLANS_SUCCESS: {
            const membershipPlansArray = getMembershipPlanModelsArray(payload);

            return {
                ...state,
                plans: [...membershipPlansArray],
                statuses: {
                    ...state.statuses,
                    arePlansLoading: false,
                },
            };
        }

        case types.ADD_MEMBERSHIP_PLAN_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isPlanAdding: true,
                },
            };
        }

        case types.ADD_MEMBERSHIP_PLAN_SUCCESS: {
            const membershipPlanModel = new MembershipPlanModel(payload);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isPlanAdding: false,
                },
                plans: [...state.plans, { ...membershipPlanModel.membershipPlan }],
            };
        }

        case types.UPDATE_MEMBERSHIP_PLAN_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isPlanUpdating: true,
                },
            };
        }

        case types.UPDATE_MEMBERSHIP_PLAN_SUCCESS: {
            const updateIndex = state.plans.findIndex(plan => plan.id === payload.id);
            const newPlansList = JSON.parse(JSON.stringify(state.plans));

            const membershipPlanModel = new MembershipPlanModel(payload);
            newPlansList[updateIndex] = { ...membershipPlanModel.membershipPlan };

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isPlanUpdating: false,
                },
                plans: [...newPlansList],
            };
        }

        case types.DELETE_MEMBERSHIP_PLAN_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isPlanDeleting: true,
                },
            };
        }

        case types.DELETE_MEMBERSHIP_PLAN_SUCCESS: {
            const newPlansList = state.plans.filter(plan => plan.id !== payload);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isPlanDeleting: false,
                },
                plans: [...newPlansList],
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/MembershipPlansReducer.js